















import { Component, mixins } from '@niknevis/vue-modules'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import DialogMixin from '@/modules/common/dialog/mixins/DialogMixin'
import AdminDepartmentCreateForm from '@/modules/department/components/admin/form/AdminDepartmentCreateForm.vue'

@Component({
  components: {
    AdminDepartmentCreateForm,
    Modal
  }
})
export default class AdminDepartmentCreateDialog extends mixins(DialogMixin) {
  protected modalVisibility: boolean = false
}
